import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/apiClient.ts'

type UseGetContentByPageArgs = {
  documentId: string
  pageNum?: number
}

export const generateOptions = (args: UseGetContentByPageArgs) =>
  queryOptions({
    queryKey: ['thumbnail', args.documentId, args],
    queryFn: async () =>
      apiClient['document-contents'][':documentId'][':pageNum']
        .$get({
          param: {
            documentId: args.documentId,
            pageNum: args.pageNum ? String(args.pageNum) : undefined,
          },
        })
        .then(async (r) => await r.json()),
    staleTime: 60 * 10 * 1000,
  })

export const useGetContentByPage = (
  args: UseGetContentByPageArgs,
  options?: Partial<ReturnType<typeof generateOptions>>
) =>
  useQuery({
    ...generateOptions(args),
    ...options,
  })

useGetContentByPage.queryOptions = generateOptions
